/**
 * Native ad units. NativeAdComponent renders these as the network's snippet:
 * a `<div id="{containerId}">` plus an async `data-cfasync="false"` script.
 *
 * Not currently rendered — AD_SLOTS has no `type: 'native'` entry (banners
 * only). To turn native back on, add one, e.g. `{ afterIndex: 6, type: 'native' }`.
 * Native is mobile-only; on desktop the resolver serves a banner in that slot.
 *
 * The `plNNNNNNNN` subdomain is per-unit and is NOT derivable from the id —
 * copy it verbatim from the snippet the network gives you.
 */
export const NATIVE_ADS = {
  primary: {
    id: '10cb4a80532e9417e36cb6bef139efa4',
    containerId: 'container-10cb4a80532e9417e36cb6bef139efa4',
    scriptSrc:
      'https://pl30401463.effectivecpmnetwork.com/10cb4a80532e9417e36cb6bef139efa4/invoke.js'
  },
};
